<template>
  <v-row v-if="inventario" no-gutters>
    <v-col cols="12">
      
      <v-row class="mb-8">
        <v-col cols="12" sm="6" md="3">
          <div class="kpi-card pa-4 rounded-xl border-subtle">
            <div class="grey--text text-overline font-weight-black mb-1">Total Sistema</div>
            <div class="white--text text-h5 font-weight-black">
              {{ inventario.totales.total_sistema }} <span class="text-caption grey--text">uds.</span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="kpi-card pa-4 rounded-xl border-subtle">
            <div class="grey--text text-overline font-weight-black mb-1">Total Física</div>
            <div class="white--text text-h5 font-weight-black">
              {{ inventario.totales.total_fisica }} <span class="text-caption grey--text">uds.</span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="kpi-card pa-4 rounded-xl border-subtle">
            <div class="grey--text text-overline font-weight-black mb-1">Diferencia Total</div>
            <div 
              class="text-h5 font-weight-black"
              :class="inventario.totales.diferencia_total < 0 ? 'red--text text--lighten-1' : 'green--text'"
            >
              {{ inventario.totales.diferencia_total > 0 ? '+' : '' }}{{ inventario.totales.diferencia_total }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="kpi-card pa-4 rounded-xl border-subtle highlight-kpi">
            <div class="white--text text-overline font-weight-black mb-1">Valorización</div>
            <div class="white--text text-h5 font-weight-black">
              {{ inventario.totales.valorizacion_total | convertPesoArg }}
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="d-flex align-center mb-4 px-1">
        <v-icon x-small color="grey" class="mr-2">mdi-format-list-bulleted-type</v-icon>
        <span class="grey--text text-caption font-weight-black letter-spacing-1">DESGLOSE POR CATEGORÍA</span>
      </div>

      <div class="categories-wrapper">
        <categoria-resumen
          v-for="cat in categorias"
          :key="cat.nombre"
          :categoria="cat"
          class="mb-4"
        />
      </div>

    </v-col>
  </v-row>

  <v-row v-else>
    <v-col cols="12">
      <v-skeleton-loader type="article, stats-grid" dark></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
import CategoriaResumen from "@/views/empresa/sucursales/productos/inventario/components/CategoriaResumen.vue";
import InventarioAPI from "@/api/inventario";
import moment from "moment";

export default {
  name: "SucursalInventarioResumen",
  components: { CategoriaResumen },
  props: {
    inventarioUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      categorias: [],
      inventario: null,
      moment: moment,
    };
  },
  methods: {
    getInventario() {
      InventarioAPI.getResumen(this.inventarioUuid)
        .then((res) => {
          this.inventario = res.data;
          this.categorias = res.data.categorias || [];
        })
        .catch((err) => console.error("Error al obtener inventario:", err));
    },
  },
  created() {
    this.getInventario();
  },
};
</script>

<style lang="scss" scoped>
.kpi-card {
  background-color: rgba(255, 255, 255, 0.03);
  border: 1px solid #222 !important;
  transition: transform 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    border-color: #333 !important;
  }
}

.highlight-kpi {
  background: linear-gradient(145deg, #1e1e1e, #111) !important;
  border: 1px solid #444 !important;
}

.border-subtle {
  border: 1px solid #222 !important;
}

.letter-spacing-1 {
  letter-spacing: 1.2px;
}

// Estilos para inyectar en el componente hijo CategoriaResumen
.categories-wrapper ::v-deep {
  .v-card {
    background-color: #1a1a1a !important;
    border: 1px solid #222 !important;
    border-radius: 12px !important;
    box-shadow: none !important;
  }
  
  .v-data-table {
    background-color: transparent !important;
  }

  .v-data-table th {
    color: #666 !important;
    font-size: 10px !important;
    text-transform: uppercase;
  }
  
  .v-data-table td {
    border-bottom: 1px solid #222 !important;
    color: #ccc !important;
  }
}
</style>